import { FC } from 'react'
import { Icon, Text } from '@/client/components'
import * as S from './styles'
import { ResultFooterProps } from '../types'

export const ResultFooter: FC<ResultFooterProps> = ({ texts, compactView = false }) => {
  if (compactView) {
    return (
      <S.ResultFooterWrapper>
        <S.ResultFooterCompact>
          <Text size='xxs' color='weak' margin='0' padding='0' align='center'>
            {texts.footer_message}
          </Text>
        </S.ResultFooterCompact>
      </S.ResultFooterWrapper>
    )
  }

  return (
    <S.ResultFooterWrapper>
      <S.ResultFooter>
        <S.ExtraInfosItemBlock>
          <Icon name='percent' size='s5' className='header-icon' />
          <Text size='xxs' color='weak' margin='0' padding='0 0 0 0'>
            {texts.footer_message}
          </Text>
        </S.ExtraInfosItemBlock>
        <S.DividerLine />
        <S.ExtraInfos>
          <S.ExtraInfosItem href={texts?.extra?.file_link} target='_blank'>
            <Icon name='info-light' size='s5' className='header-icon' />
            <Text size='xxs' color='weak' margin='0' lineHeight='1.3'>
              {texts?.extra?.file_label}
            </Text>
            <Icon name='circle-arrow-right' size='s4' className='qoutation-forwards' />
          </S.ExtraInfosItem>
        </S.ExtraInfos>
        <S.DividerLine />
        <S.ExtraInfosItemBlock>
          <Icon name='play-vid' size='s5' className='header-icon' />
          <S.Paragraph
            dangerouslySetInnerHTML={{ __html: texts.more_info.info_sentence }}
            style={{ fontSize: '0.648rem', padding: '0', margin: '0' }}
          />
          <Icon name='circle-arrow-right' size='s4' className='qoutation-forwards' />
        </S.ExtraInfosItemBlock>
        <S.DividerLine />
        <S.ExtraInfos>
          <S.ExtraInfosItemSmall href={texts?.help?.file_link} target='_blank'>
            <Icon name='phone-signal' size='s5' className='header-icon' />
            <S.Paragraph
              dangerouslySetInnerHTML={{ __html: texts?.help?.file_label }}
              style={{ fontSize: '0.648rem', padding: '0', margin: '0' }}
            />
            <Icon name='circle-arrow-right' size='s4' className='qoutation-forwards' />
          </S.ExtraInfosItemSmall>
        </S.ExtraInfos>
      </S.ResultFooter>
    </S.ResultFooterWrapper>
  )
}
